export class RetryConsumerMessageDto{
    id: number;
    jsonRetry: string;

    constructor(id:number, jsonRetry: string){
        this.id = id;
        this.jsonRetry = jsonRetry;
    }
}
